import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss'],
  standalone: false
})
export class SignaturePadComponent implements AfterViewInit {

  @ViewChild('canvas', {static: true}) signaturePadElement!: ElementRef<HTMLCanvasElement>;

  pad!: SignaturePad;

  constructor(
    protected elementRef: ElementRef,
  ) {
  }


  ngAfterViewInit(): void {
    setTimeout(() => this.initPad(), 100);
  }


  /**
   * Inicializar cuaderno
   *
   */
  initPad() {
    const padWrapper = this.elementRef.nativeElement.querySelector('.pad-wrapper');

    this.signaturePadElement.nativeElement.height = 180;
    this.signaturePadElement.nativeElement.width = padWrapper.offsetWidth || window.innerWidth;

    this.pad = new SignaturePad(this.signaturePadElement.nativeElement);
    this.pad.clear();
  }


  /**
   * Limpiar firma
   *
   */
  drawClear() {
    this.pad.clear();
  }

}
